import { StyleSheet, Dimensions, Platform } from 'react-native';
import colors from '../constants/colors';

const screenWidth = 390;
const screenHeight = 844;

const styles = StyleSheet.create({
  rootConatiner: {
    width:screenWidth,
    height:screenHeight,

    backgroundColor: colors.background,
  },
  container: {
    width: screenWidth,
    height: screenHeight,

    backgroundColor: colors.background,
  },
   glow: {
    position: "absolute",
    height: 120,
    left: 0,
    right: 0,
    backgroundColor: "rgba(255,255,255,0.25)", // your green
    borderRadius: 100,
  },

  glowVertical: {
    position: "absolute",
    width: 120,
    top: 0,
    bottom: 0,
    backgroundColor: "rgba(28,236,128,0.2)",
    borderRadius: 100,
  },

  top: {
    top: -40,
  },

  bottom: {
    bottom: -40,
  },

  left: {
    left: -40,
  },

  right: {
    right: -40,
  },

  tableContainer: {
    // shadowColor: '#D9D9D9', // white glow color
    // shadowOffset: { width: 0, height: 0 },
    // shadowOpacity: 0.4,
    // shadowRadius: 80,
    // borderRadius: 800, // optional: smooth circle edge
    // elevation: 40,
    // borderWidth: 1,
  //marginTop: 50,
//    boxShadow: '0px 0px 80px rgba(217,217,217,0.4)',
// backgroundColor: 'rgba(255,255,255,0.02)',
  ...(Platform.OS === "web"
    ? {
        boxShadow: "0px 0px 80px 30px rgba(217,217,217,0.45)",
        filter: "drop-shadow(0px 0px 80px rgba(217,217,217,0.4))",
      }
    : {}),
    borderColor: 'transparent',
    height: screenHeight,
    width: screenWidth ,
    alignSelf: 'center',
    //backgroundColor:"red"
  },

  tableContainerSquid: {
   // marginTop: 30,
    borderColor: 'transparent',
    height: Dimensions.get('screen').height - 200,
    width: Dimensions.get('screen').width - 10,
    alignSelf: 'center',
  },
  actionButtonContainer: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',
    alignSelf: 'center',
    position: 'absolute',
    bottom: 10,
  },
  actionButtonContainer2: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    width: '100%',

    alignSelf: 'center',
  },
  gameRulesContainer: {
    position: 'absolute',
    top: 15,
    right: 40,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: 'white',
    height: 30,
    width: 50,
    borderRadius: 15,
  },
  gameRulesTxt: {
    color: colors.primary,
    fontSize: 10,
    fontFamily: 'Inter-Regular',
  },
  hamburgerIcon: {
    position: 'absolute',
    top: 20,

    left: 6,
  },

  chatIcon: {
    position: 'absolute',
    bottom: 90,
    right: 10,
  },
  clockIcon: {
    position: 'absolute',
    bottom: 120,
    left: 10,
  },
  clock: {
    height: 30,
    width: 30,
  },
  clockTxt: {
    fontSize: 10,
    position: 'absolute',
    top: 12,
    left: 7,
    fontFamily: 'AvertaStd-Bold',
    fontWeight: 'bold',
    color: 'black',
  },
  realTimeResultsIcon: {
    position: 'absolute',
    top: 60,

    right: 10,
  },
  handHisotryIcon: {
    position: 'absolute',
    top: 60,
    left: 10,
  },
  octopusIcon: {
    position: 'absolute',
    top: 90,
    left: 10,
  },
  addOnIcon: {
    position: 'absolute',
    top: 90,
    backgroundColor:colors.toggleBg,
    justifyContent:"center",alignItems:"center",
    borderWidth:0.5,
    borderColor:colors.lemonFlash,
    height:25,width:25,borderRadius:25/2,
    left: 10,
  },

   ftDealBox: {
    position: 'absolute',
    top: 90,
    backgroundColor:'rgba(0,0,0,0.6)',
    justifyContent:"center",alignItems:"center",
    borderWidth:0.5,
     
    height:45,width:45,
    borderRadius:5,
    left: 10,
  },
  menuIcon: {
    position: 'absolute',
    top: 20,
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
    //backgroundColor:"red",
    right: 10,
  },
  bottomTab: {
    backgroundColor: colors.bottomTabBackground,
    flex: 1,
    flexDirection: 'row',
    width: '100%',
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    height: 75,
    position: 'absolute',
    bottom: 0,
    //justifyContent: 'center',
    //alignItems: 'center',
  },
  bottomIconContainer: {
    height: 30,
    width: 30,
    marginTop: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  tabTxt: {
    color: colors.white,
    fontFamily: 'Inter-Regular',
    fontSize: 10,
    marginTop: 4,
    textAlign: 'center',
  },
  octopusTxt: {
    color: colors.lemonFlash,
    fontSize: 12,
    marginLeft: 15,
    marginTop: -15,
    fontFamily: 'AvertaStd-ExtraBold',
  },
   addOnTxt: {
    color: colors.primary,
    fontSize: 14,
   
    fontFamily: 'AvertaStd-ExtraBold',
  },
  ftDealTxt: {
    color: colors.primary,
    fontSize: 12,
   
    fontFamily: 'AvertaStd-Bold',
  },
  ftDealTxt2: {
    color: colors.white,
    fontSize: 10,
   
    fontFamily: 'AvertaStd-Bold',
  },
  tabContainer: {
    width: screenWidth / 4 - 3,
    flexDirection: 'column',
    alignItems: 'center',
  },
  toggleContainerBg: {
    backgroundColor: colors.toggleBg,
    width: '46%',
    height: 45,
    margin: 5,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  toggleTxt: {
    color: colors.white,
    fontFamily: 'Inter-Regular',
    fontSize: 12,
    fontWeight: '400',
    width: '60%',
    margin: 3,
  },
  profileContainer: {
    width: 50,
    height: 50,
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileContainerSitOut: {
    width: 48,
    height: 48,
    borderRadius: 48 / 2,
    top: 0,
    zIndex: 100,
    backgroundColor: 'rgba(0,0,0,0.7)',
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileContainerSitOutTrans: {
    width: 40,
    height: 40,
    borderRadius: 40 / 2,
    top: 8,
    zIndex: 100,
    backgroundColor: 'transparent',
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sitOutTxt: {
    color: colors.white,
    fontSize: 7,
    fontFamily: 'AvertaStd-Regular',
  },
  frame: {
    width: 50,
    height: 50,
    position: 'absolute',
    zIndex: 1,
  },
   seatRankTxt: {
    color: colors.black,
    fontSize: 9,
     zIndex: 9999,
    fontFamily: 'AvertaStd-Bold',
  },
   rankBadge: {
    width: 40,
    height: 25,
    top:-2,
    flexDirection:"row",
    justifyContent:"center",
    alignItems:"center",
    position: 'absolute',
    zIndex: 999,
  },
  profile: {
    width: 40, // slightly smaller to fit inside frame
    height: 40,
    borderRadius: 25,
    zIndex: 0,
    backgroundColor: 'black',
  },
  lastActionContainer: {
    position: 'absolute',
    bottom: 1.5,
    backgroundColor: 'rgba(0,0,0,0.7)',
    zIndex: 200,
    width: 40,
    height: 15,
    borderRadius: 3,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    // iOS Shadow
    shadowColor: 'red',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    // Android Shadow
    elevation: 6,
  },

   lastActionContainer2: {
    position: 'absolute',
    top: 12,
    backgroundColor: 'rgba(0,0,0,0.7)',
    zIndex: 200,
    width:60,
    height: 15,
    borderRadius: 3,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    // iOS Shadow
    shadowColor: 'red',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    // Android Shadow
    elevation: 6,
  },
  lastActionTxt: {
    fontSize: 8,
    fontFamily: 'AvertaStd-Bold',
  },
  detailsContainer: {
    position: 'absolute',
    flex: 1,
    top: -14,
    left: -30,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 60,
  },

   detailsContainer2: {
    position: 'absolute',
   
    top: -14,
    left: -20,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 100,
  },
  detailsContainerSitOut: {
    position: 'absolute',
    flex: 1,
    top: -5,
    height: 35,
    left: -32,
    borderRadius: 7,

    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 63,
    backgroundColor: 'rgba(0,0,0,0.7)',
  },
  nameTxt: {
    textAlign: 'center',
    color: colors.white,
    fontSize: 7,
    width: '80%',

    fontFamily: 'AvertaStd-Bold',
    paddingTop: 17,
  },
  stackTxt: {
    color: colors.secondary,
    fontSize: 8,
    paddingTop: 0.5,
    fontFamily: 'AvertaStd-Bold',
  },
  communityCard: {
    height: '100%',
    width: '100%',
  },
  cardWrapper: {
     width: 40,
    height: 52,
    // borderWidth: 1,
    //borderColor: 'black',
    alignItems: 'center',
  },
  cardWrapper2: {
    width: 25,
    height: 40,
    padding: 1,
    // borderWidth: 1,
    //borderColor: 'black',
    alignItems: 'center',
  },
  card: {
    width: '100%',
    height: '100%',
  },
  fullmodal: {
    backgroundColor: 'transparent',
    margin: 0, // This is the important style you need to set
    alignItems: undefined,

    justifyContent: undefined,
  },
  tempModal: {
    width: '100%',
    height: '75%',
    backgroundColor: 'pink',
  },

  fullmodalIllusion: {
    width: screenWidth,
    height: '90%',
    position: 'absolute',
    //backgroundColor:"red",
  },
  tableInfoContainer: {
    position: 'absolute',
    alignSelf: 'center',
    top: '68%',
    //backgroundColor:"red",
    zIndex: 999,
    width: '60%',
  },
  mttCountDownImage:{width:"100%",height:"100%",justifyContent:"center",alignItems:"center",flexDirection:"row"},

  mttCountdownContainer: {
    position: 'absolute',
    alignSelf: 'center',
    top: '45%',
    //backgroundColor:"red",
    zIndex: 999,
    height:50,
    width: '40%',
    //flexDirection:"row",
    justifyContent:"center",
    alignItems:"center"
  },
  blackBoxTime:{
   height:35,
   width:25,
   margin:2,
   backgroundColor:colors.black,
   borderRadius:5,
   justifyContent:"center",
   alignItems:"center"
  },
    timertxt: {
      color: colors.white,
      textAlign: 'center',
     // marginTop: 40,
      fontFamily: 'digital-7',
      //letterSpacing: 5,
      fontSize: 30,
    },
  potContainer: {
    position: 'absolute',
    alignSelf: 'center',
    top: '23%',

    height: 100,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    //backgroundColor: 'pink',
    width: '45%',
  },
  boardContainer: {
    position: 'absolute',
    alignSelf: 'center',
    top: '35%',
    width: '60%',
    zIndex:999
  },
  board1: {
    height: 45,
    alignSelf: 'center',
    alignItems: 'center',
    width: '90%',
    //backgroundColor:'red',
    position: 'absolute',
    flexDirection: 'row',
  },
  board2: {
    height: 45,
    //marginTop: 10,
    alignSelf: 'center',
    position: 'absolute',
    alignItems: 'center',
    width: '90%',
    // backgroundColor:"pink",
    flexDirection: 'row',
  },
  board3: {
    height: 45,
    marginTop: 110,
    alignSelf: 'center',
    position: 'absolute',
    alignItems: 'center',
    width: '90%',
    // backgroundColor:"pink",
    flexDirection: 'row',
  },
  boardChild: {
    width: '100%',
    height: '100%',
    flexDirection: 'row',
    position: 'relative',

    //alignItems: 'center',
  },
  keypadCon: { width: '85%', height: 150, position: 'absolute', right: -5 },
  multiplyCon: {
    width: '50%',
    height: 140,
    position: 'absolute',
    right: 0,
    bottom: 0,
  },
  raiseModal: {
    backgroundColor: 'transparent',
    margin: 0, // This is the important style you need to set
    alignItems: undefined,
    justifyContent: undefined,
  },
  raiseCon: {
    width: '100%',
    // height: '15%',
    position: 'absolute',

    //flexDirection:"row",
    //backgroundColor:"yellow",
  },
  raiseCon2: {
    position: 'absolute',
    bottom: 2,
    //backgroundColor:"red",
    right: 5,
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },

  raiseBtn: {
    height: 30,
    width: 30,
    borderRadius: 30 / 2,
    margin: 2,
  },
  alertmodal: {
    width: '100%',
    height: '15%',
    position: 'absolute',
    top: '15%',
    backgroundColor: 'transparent',
  },

  ritModal: {
    width: '100%',
    height: '90%',
    backgroundColor: colors.toggleBg,
    borderRadius: 20,
    position: 'absolute',
    top: '5%',
    alignItems: 'center',
  },
  ritModalHeaderTxt: {
    color: colors.white,
    fontSize: 18,
    fontFamily: 'AvertaStd-Bold',
    textAlign: 'center',
    marginTop: 16,
  },
   mttStartTxt: {
    color: colors.white,
    fontSize: 12,
    fontFamily: 'AvertaStd-Bold',
    textAlign: 'center',
    marginTop: 3,
  },
  ritModalTxt: {
    color: colors.white,
    fontSize: 16,
    fontFamily: 'AvertaStd-Regular',
    textAlign: 'center',
    marginTop: 5,
  },
  ritTxt: {
    color: colors.white,
    fontSize: 14,
    fontFamily: 'AvertaStd-Regular',
    //textAlign: 'center',
    marginTop: 8,
  },
  ritBtnCon: {
    marginTop: 0,
    height: '95%',
  },
    riskBtnCon: {
    marginTop: 0,
    width:"90%",
    //backgroundColor:"red",
    height: '95%',
  },
  insBtnCon: {
    width:"100%",
    //backgroundColor:"blue",
    flexDirection:"row",
    
    position:"absolute",
    bottom:5,
    justifyContent:"center",
    alignItems:"center"
    //height: '95%',
  },
  ritModalYellowTxt: {
    color: colors.yellowtxt,
    fontSize: 16,
    fontFamily: 'AvertaStd-Regular',
    textAlign: 'center',
  },
  ritModalYellowTxtFloating: {
    color: colors.yellowtxt,
    fontSize: 13,
    position:"absolute",
    top:8,
    right:8,
    fontFamily: 'AvertaStd-Regular',
    textAlign: 'center',
  },
  ritModalWhiteTxt: {
    color: colors.white,
    fontSize: 16,
    fontFamily: 'AvertaStd-Regular',
    textAlign: 'center',
  },
   insModalWhiteTxt: {
    color: colors.white,
    fontSize: 12,
    fontFamily: 'AvertaStd-Regular',
    textAlign: 'center',
  },
  modalRitRow: {
    marginTop: 15,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  line: {
    width: '95%',
    height: 0.2,
    marginTop: 10,
    backgroundColor: colors.offWhite,
  },
  subHeaderRow: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    backgroundColor: colors.darkGray,
    marginTop: 3,
    height: 30,
    marginTop: 13,
    padding: 5,
    justifyContent: 'space-between',
  },
  potsRow: {
   // flexDirection: 'row',
    width: 80,
    alignItems: 'center',
    backgroundColor: colors.darkGray,
    margin:3,
    height: 40,
    padding: 5,
   
  },
  halfModal: {
    padding: 2,
    width: '50%',
    height: 200,
    borderRightWidth: 0.3,
    borderRightColor: colors.offWhite,
  },

  halfModal2: {
    padding: 2,
    width: '50%',
    height: 200,
    
    padding: 5,
  },

   halfModalI: {
    padding: 2,
    width: '50%',
    height: 250,
    borderRightWidth: 0.3,
    borderRightColor: colors.offWhite,
  },

  halfModal2I: {
    padding: 2,
    width: '50%',
    height: 250,
    
    padding: 5,
  },
  premiumContainer:{
 
  flexDirection:"row",
  
  width:"100%",
 
  justifyContent:"center",
  alignItems:"center",
  marginTop:10
  },
  premTxt1:{
    color: colors.actionBtnTxt,
    fontSize: 12,
     textAlign:"center",
    fontFamily: 'AvertaStd-Regular',

  },
  premTxt1Err:{
    color: colors.red,
    fontSize: 12,
    marginTop:10,
     textAlign:"center",
    fontFamily: 'AvertaStd-Regular',

  },
  premTxt2:{
    color: colors.white,
    fontSize: 12,
    textAlign:"center",
    fontFamily: 'AvertaStd-Regular',

  },
  greenBtnTxt:{
    color: colors.offWhite,
    fontSize: 10,
    textAlign:"center",
    fontFamily: 'AvertaStd-Regular',

  },
  premCon:{
    borderWidth:0.5,
    height:25,
    width:"100%",
    
    justifyContent:"center",alignItems:"center",
    borderColor:colors.primary


  },
  greenBtn:{
    width:"75",
    height:20,
    backgroundColor:colors.primary,
    borderRadius:2,
    justifyContent:"center",
    alignItems:"center",
    marginTop:5,
  },
  conCalculate:{
    height:60,
    width:"25%",
    justifyContent:"center",alignItems:"center"

  },
  conCalculateIcon:{
     height:60,
    width:"10%",
    justifyContent:"center",alignItems:"center"

  },

  triangleCorner:{
     position: "absolute",
      top: 0,
      right: 0,
      width: 0,
      height: 0,
      borderTopWidth: 8,
      borderRightWidth: 8,
      borderTopColor: colors.primary,
      borderRightColor: "transparent",
      transform: [{ rotate: "90deg" }]

  },

  dealerContainer: {
    backgroundColor: colors.betYellowBg,
    height: 15,
    width: 15,
    borderRadius: 15 / 2,
    position: 'absolute',
    top: 4,
    left: -10,
    zIndex: 9999,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dealerPosition: {
    position: 'absolute',
    top: 3,
    left: -18,
    zIndex: 9999,
  },
  dealerTxt: {
    color: colors.white,
    fontSize: 7,
    fontFamily: 'AvertaStd-Regular',
  },
  postBlindTxt: {
    color: colors.white,
    fontSize: 14,
    marginLeft: 8,
    fontFamily: 'AvertaStd-Regular',
  },
  postBlind: {
    flexDirection: 'row',
    position: 'absolute',
    bottom: 90,
    left: 10,
  },
  tickbox: {
    backgroundColor: colors.primary,
    height: 20,
    width: 20,
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  winPointCon: {
    height: 18,
    width: '100%',
    left: 0,
    top: -18,
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
  },
  winTxt: {
    backgroundColor: 'rgba(0,0,0,0.3)',
    borderRadius: 4,
    color: colors.betYellowBorder,
    fontSize: 10,

    fontFamily: 'AvertaStd-Bold',
  },
  winTxt2: {
    borderRadius: 4,
    color: colors.white,
    fontSize: 10,
    marginTop: 5,
    textAlign: 'center',
    fontFamily: 'AvertaStd-Bold',
  },
  handDesc: {
    width: '100%',
    backgroundColor: 'Red',
    position: 'absolute',
    flexDirection: 'column',
    top: 250,
  },

  squidDesc: {
    width: '100%',
    backgroundColor: 'Red',
    position: 'absolute',
    flexDirection: 'column',
    top: "40%",
  },
    squidCountdown: {
    width: '100%',
  
    position: 'absolute',
    flexDirection: 'column',
    top: "35%",
  },
  countdownTxt:{
    color: colors.white,
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'AvertaStd-Bold',

  },
  squidConfirm:{
    
    width:"60%",
    height:30,
    borderRadius:7,
    alignSelf:"center",
    marginTop:5,
    justifyContent:"center",
    alignItems:"center"

  },
  squidTxtConfirm:{
     color: colors.white,
    fontSize: 14,
    textAlign: 'center',
    fontFamily: 'AvertaStd-Bold',
  },

  ritMsg: {
    width: '100%',
    backgroundColor: 'Red',
    position: 'absolute',
    flexDirection: 'column',
    top: '40%',
  },
  handDescBottom: {
    width: '70%',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',

    flexDirection: 'column',
    position: 'absolute',
    bottom: 250,
    height: 50,
  },
  handDescCon1: {
    width: '100%',
    height: 45,
    backgroundColor: 'rgba(0,0,0,0.4)',

    justifyContent: 'center',
    alignItems: 'center',
  },
  squidDescCon1: {
    width: '100%',
    height: 45,
    backgroundColor: 'rgba(255, 0, 0, 0.4)',

    justifyContent: 'center',
    alignItems: 'center',
  },
  handDescCon2: {
    width: '100%',
    marginTop: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  handRanking: {
    width: 100,
    position: 'absolute',
    right: -105,
    top: 50,
    padding: 1,
  },
  handRanking2: {
    width: 100,
    position: 'absolute',
    right: -105,
    top: 60,
    padding: 1,
  },

  handRanking3: {
    width: 100,
    position: 'absolute',
    right: -105,
    top: 70,
    padding: 1,
  },
  handRankTxt: {
    color: colors.white,
    fontSize: 10,
    marginLeft: 14,
    fontFamily: 'AvertaStd-Bold',
  },
  winPercentage: {
    width: 100,
    position: 'absolute',
    left: -60,
    top: 60,
    padding: 1,
  },
  winPercentageTxt: {
    color: colors.white,
    fontSize: 8,
    fontFamily: 'AvertaStd-Regular',
  },

  msg: {
    fontSize: 11,
    color: colors.white,
    fontFamily: 'AvertaStd-Regular',

    minWidth: 40,
    textAlign: 'center',
    // alignItems:'center',
    flexShrink: 1, // 👈 lets text wrap instead of cut
    flexWrap: 'wrap', // 👈 ensures wrapping
  },
  voicemsg: {
    minWidth: 20,
  },
  row: {
    // full row so we can align left/right/center, but DO NOT set width on the bubble
    width: '100%',
    flexDirection: 'row',
    alignSelf: 'center',
    alignItems: 'center',
  },
  // No fixed width here — this lets the bubble size to its content
  wrap: {
    position: 'relative',
    alignSelf: 'flex-start',
    flexShrink: 1, // allow wrap to shrink if near screen edge
  },
  bubble: {
    paddingHorizontal: 5,
    paddingVertical: 5,
    borderRadius: 5,
    overflow: 'visible',
    // subtle shadow
    shadowColor: '#000',
    shadowOpacity: 0.25,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 2,
    backgroundColor: colors.red,
    alignSelf: 'flex-start',
    maxWidth: '70%',
    marginHorizontal: 10,
  },

  tailContainer: {
    marginTop: -2, // just above the profile
    alignItems: 'center', // 👈 ensures tail is centered with parent
    justifyContent: 'center',
  },
  tailBottom: {
    position: 'absolute',
    width: 0,
    height: 0,
    borderLeftWidth: 6,
    borderRightWidth: 6,
    borderTopWidth: 8,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: colors.toggleBg,
    marginTop: -2,
  },
  wrapper: {
    alignItems: 'center', // 👈 ensures bubble + tail are centered
    backgroundColor: 'pink',
  },
  straddleTagCon: {
    width: 40,
    transform: [{ rotate: '-35deg' }],
    position: 'absolute',
    top: -9,
    left: -14,
  },
  starddleTagStick: {
    backgroundColor: colors.yellow,
    height: 7,
    width: 2,
    alignSelf: 'center',
  },
  starddleTagTxt: {
    color: colors.black,
    fontSize: 6,
    fontFamily: 'AvertaStd-Bold',
  },
  staddleBanner: {
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.yellow,
    height: 10,
    width: 27,
    borderRadius: 2,
  },
  straddleActionCon: {
    height: 10,
    width: 35,
    zIndex: 1000,
    position: 'absolute',
    top: 2,
    left: 16,
    borderRadius: 5,
    backgroundColor: colors.profileGradient1,
  },
  straddleActionTxt: {
    color: colors.offWhite,
    fontSize: 7,
    textAlign: 'center',
    fontFamily: 'AvertaStd-Bold',
  },
  mystryCon:{
  // backgroundColor:"red",
    position: 'absolute',
    top: '2%',
    right: '10%',
    zIndex: 9999,
  },
  bombpotCon: {
    // backgroundColor:"red",
    position: 'absolute',
    top: '25%',
    left: '25%',
    zIndex: 9999,
  },
  chatmessage: {
    position: 'absolute',
    bottom: 120,
    right: 2,
    paddingHorizontal: 5,
    paddingVertical: 5,
    borderRadius: 5,
    overflow: 'visible',
    // subtle shadow
    shadowColor: '#000',
    shadowOpacity: 0.25,
    shadowRadius: 8,
    shadowOffset: { width: 0, height: 2 },
    elevation: 10,
    backgroundColor: colors.toggleBg,
    alignSelf: 'center',
    maxWidth: '70%',
    marginHorizontal: 10,
    zIndex: 9999, // 👈 force chat bubble always on top
  },
  tailBottom2: {
    position: 'absolute',
    bottom: -8, // 👈 stick tail below bubble
    // left: 30,           // 👈 move tail to bottom-left corner
    width: 0,
    height: 0,
    borderLeftWidth: 8,
    borderRightWidth: 8,
    borderTopWidth: 10,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: colors.toggleBg, // 👈 same as bubble
    right: 10,
  },
  messageText: {
    fontSize: 12,
    color: colors.white,
    fontFamily: 'AvertaStd-Regular',
    minWidth: 40,
    maxWidth: 130,
    textAlign: 'center',
  },
  voicemsg2: {
    minWidth: 40,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
  gameHeaderButtonConatiner: {
    position: 'absolute',
    top: 15,
    left: 0,
    right: 0,
    alignItems: 'center',
  },
  activeGreenButton: {
    backgroundColor: colors.primary,
    borderRadius: 25,
    height: 30,
    width: 64,
    borderWidth: 1,
    borderColor: colors.white,
    alignItems: 'center',
    justifyContent: 'center',
  },
  inactiveWhiteButton: {
    backgroundColor: colors.white,
    borderRadius: 25,
    height: 30,
    width: 64,
    borderWidth: 1,
    borderColor: colors.white,
    alignItems: 'center',
    justifyContent: 'center',
  },
  greenButtonTextUnique: {
    color: colors.actionBtn1,
    fontSize: 10,
    fontFamily: 'AvertaStd-Semibold',
  },
  grayButtonUnique: {
    backgroundColor: '#F5F5F5',
    borderRadius: 25,
    height: 30,
    width: 62,
    borderWidth: 1,
    borderColor: colors.white,
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  closeIconSquid: {
    //marginTop: 25,
      width:40,
   position:"absolute",
    right:35,
    top:10,
    justifyContent:"center",
    alignItems:"center",
    height:40,
    //backgroundColor:"red",
    //alignSelf: 'flex-end',
    
  },
  goldheading: {
    fontSize: 20,
    marginTop: 40,
    
  // backgroundColor:"red",
    color: colors.yellow,
    textAlign: 'center',
    fontFamily: 'AvertaStd-Bold',
  },
    goldheading2: {
    fontSize: 20,
    marginTop: 10,
    
  // backgroundColor:"red",
    color: colors.yellow,
    textAlign: 'center',
    fontFamily: 'AvertaStd-Bold',
  },
  handCount:{
    width:120,
    justifyContent:"center",
    alignItems:"center",
    height:20,
    marginTop:5,
    alignSelf:"center",
   borderRadius:8,
    backgroundColor:'rgba(0,0,0,0.5)'
  },
  handTxt:{
    fontSize: 12,
   
    color: colors.yellow,
    textAlign: 'center',
    fontFamily: 'AvertaStd-Regular',

  },
   squidTxt:{
    fontSize: 12,
   
    color: colors.yellow,
    textAlign: 'left',
   
    
    fontFamily: 'AvertaStd-Regular',

  },
  squidDetailCon:{
   //backgroundColor:"pink",
   width:"80%",
   left:"10%",
   height:"80%",
   marginTop:40,
   position:"absolute"
  },
  squidList:{
    width:"75%",
    marginTop:10,
    //backgroundColor:"red",
    height:"58%",
    alignSelf:"center"
  },
  
});

export { styles };
